/****************************************************
 * CHUNK #1: Core Variables & Session Storage
 ****************************************************/
let selectedQuantity = 6;
let selectedSize = "large";
let selectedColor = "beige";

// Maps size+color combinations to variant IDs (1-9)
function getVariantId(size, color) {
  const map = {
    "small-beige": 1,
    "medium-beige": 2,
    "large-beige": 3,
    "small-orange": 4,
    "medium-orange": 5,
    "large-orange": 6,
    "small-white": 7,
    "medium-white": 8,
    "large-white": 9,
  };
  return map[`${size}-${color}`] || 1;
}

// Constructs product query string for checkout
function buildProductsString() {
  const variantID = getVariantId(selectedSize, selectedColor);
  const mainPart = `570.${variantID}:${selectedQuantity}`;
  
  let giftsPart = "";
  if (selectedQuantity === 4) {
    giftsPart = ";20.30:1";
  } else if (selectedQuantity === 6) {
    giftsPart = ";20.30:1;50.60:1;70.100:1";
  }
  
  return `?products=${mainPart}${giftsPart}`;
}

// Returns discount code based on quantity
function buildDiscountCode() {
  if (selectedQuantity === 2) return "pp-10";
  if (selectedQuantity === 4) return "pp-20";
  return "pp-30";
}

// Updates session storage with current selections
function updateSessionStorage() {
  const productsStr = buildProductsString();
  const discountCode = buildDiscountCode();
  sessionStorage.setItem("checkoutParams", productsStr);
  sessionStorage.setItem("discountcode", discountCode);
}

/****************************************************
 * CHUNK #2: Gift Box Management
 ****************************************************/

// Locks gift box and shows quantity overlay
function lockGift(giftNumber) {
  const giftBox = document.querySelector(".gift-" + giftNumber);
  if (!giftBox) return;

  giftBox.classList.remove("gift-unlocked");
  giftBox.classList.add("gift-locked");

  const lockSpan = giftBox.querySelector(".lock");
  if (lockSpan) {
    lockSpan.classList.remove("unlocked");
    lockSpan.style.display = "block";
  }

  const overlayLabel = giftBox.querySelector(".gift-label-overlay");
  if (overlayLabel) {
    overlayLabel.textContent = giftNumber === 1 ? "x4 PuppyPads" : "x6 PuppyPads";
    overlayLabel.style.opacity = "1";
  }

  const giftImg = giftBox.querySelector(".gift-image");
  if (giftImg) {
    giftImg.style.opacity = "0";
  }
}

// Unlocks gift box with animations
function unlockGift(giftNumber) {
  const giftBox = document.querySelector(".gift-" + giftNumber);
  if (!giftBox) return;

  giftBox.classList.remove("gift-locked");
  giftBox.classList.add("gift-unlocked");

  const lockSpan = giftBox.querySelector(".lock");
  if (lockSpan) {
    lockSpan.classList.add("unlocked");
    lockSpan.style.borderColor = "red";
    setTimeout(() => {
      lockSpan.style.display = "none";
    }, 1200);
  }

  const overlayLabel = giftBox.querySelector(".gift-label-overlay");
  if (overlayLabel) {
    overlayLabel.style.opacity = "0";
  }

  const giftImg = giftBox.querySelector(".gift-image");
  if (giftImg) {
    setTimeout(() => {
      giftImg.style.opacity = "1";
    }, 600);
  }
}

/****************************************************
 * CHUNK #3: Progress Bar & Gift Updates
 ****************************************************/

// Updates progress bar width
function setProgressBarGifts(giftsUnlocked) {
  const bar = document.getElementById("gifts-progress-bar");
  if (!bar) return;
  const percent = (giftsUnlocked / 3) * 100;
  bar.style.width = Math.round(percent) + "%";
}

// Unlocks gifts in sequence with delay
function unlockInSequence(giftsArray, delayStep) {
  giftsArray.forEach((gNum, index) => {
    setTimeout(() => {
      unlockGift(gNum);
      setProgressBarGifts(index + 1);
    }, delayStep * (index + 1));
  });
}

// Updates gift states based on pad quantity
function updateGifts(numPads) {
  lockGift(1);
  lockGift(2);
  lockGift(3);
  setProgressBarGifts(0);

  if (numPads === 4) {
    unlockGift(1);
    setProgressBarGifts(1);
  } else if (numPads === 6) {
    unlockInSequence([1, 2, 3], 400);
  }
}

/****************************************************
 * CHUNK #4: DOM Ready & Event Handlers
 ****************************************************/

document.addEventListener("DOMContentLoaded", function() {
  // Initialize accordion elements
  const product3 = document.querySelector(".product-3");
  const offerAccordionHeader = document.querySelector(".offer-accordion-header");
  const offerAccordionContent = document.querySelector(".offer-content.accordion-body");
  const sizeAccordionHeader = document.querySelector(".size-accordion-header");
  const sizeAccordionContent = document.querySelector(".size-content.accordion-body");

  // Set default states
  if (offerAccordionContent) {
    offerAccordionContent.classList.add("active");
    offerAccordionContent.style.maxHeight = offerAccordionContent.scrollHeight + "px";
    const icon = offerAccordionHeader.querySelector(".accordion-icon");
    if (icon) icon.textContent = "-";
  }

  if (product3) {
    setTimeout(() => {
      product3.classList.add("active-offer-box");
      product3.click();
    }, 100);
  }

  if (sizeAccordionHeader && sizeAccordionContent) {
    sizeAccordionContent.classList.add("active");
    sizeAccordionContent.style.maxHeight = sizeAccordionContent.scrollHeight + "px";
    const icon = sizeAccordionHeader.querySelector(".accordion-icon");
    if (icon) icon.textContent = "-";
  }

  // Setup accordion click handlers
  const accordionHeaders = document.querySelectorAll(".accordion-header");
  accordionHeaders.forEach(function(header) {
    header.addEventListener("click", function() {
      let type = "";
      if (header.classList.contains("offer-accordion-header")) {
        type = "offer";
      } else if (header.classList.contains("size-accordion-header")) {
        type = "size";
      } else if (header.classList.contains("color-accordion-header")) {
        type = "color";
      }
      if (type === "offer") {
        setActiveAccordion(type, true);
      } else {
        setActiveAccordion(type);
      }
    });
  });

  // Initialize selection boxes
  setupSelectionBoxes("offer-box", "active-offer-box");
  setupSelectionBoxes("size-box", "active-size-box");
  setupSelectionBoxes("color-box", "active-color-box");

  /****************************************************
   * Accordion Management
   ****************************************************/
  function setActiveAccordion(type, allowCollapse = false) {
    const targetHeader = document.querySelector(`.${type}-accordion-header`);
    const targetContent = document.querySelector(`.${type}-content.accordion-body`);
    if (!targetHeader || !targetContent) return;

    const icon = targetHeader.querySelector(".accordion-icon");

    if (allowCollapse && targetHeader.classList.contains("active")) {
      targetHeader.classList.remove("active");
      targetContent.classList.remove("active");
      targetContent.style.maxHeight = null;
      if (icon) icon.textContent = "+";
      return;
    }

    // Close other accordions
    document.querySelectorAll(".accordion-header").forEach((hdr) => {
      if (hdr !== targetHeader && !hdr.classList.contains("offer-accordion-header")) {
        hdr.classList.remove("active");
      }
    });
    document.querySelectorAll(".accordion-body").forEach((body) => {
      if (body !== targetContent && !body.classList.contains("offer-content")) {
        body.classList.remove("active");
        body.style.maxHeight = null;
        const theirIcon = body.parentElement.querySelector(".accordion-header .accordion-icon");
        if (theirIcon) theirIcon.textContent = "+";
      }
    });

    targetHeader.classList.add("active");
    targetContent.classList.add("active");
    targetContent.style.maxHeight = targetContent.scrollHeight + "px";
    if (icon) icon.textContent = "-";
  }

  /****************************************************
   * Selection Box Management
   ****************************************************/
  function setupSelectionBoxes(boxClass, activeClass) {
    const boxes = document.querySelectorAll("." + boxClass);
    boxes.forEach(function(box) {
      box.addEventListener("click", function() {
        boxes.forEach(b => b.classList.remove(activeClass));
        this.classList.add(activeClass);

        // Handle offer selection
        if (boxClass === "offer-box") {
          if (this.classList.contains("product-1")) {
            selectedQuantity = 2;
            updateGifts(2);
            updateOfferLabel("2 PUPPYPADS (No free gifts)");
          } else if (this.classList.contains("product-2")) {
            selectedQuantity = 4;
            updateGifts(4);
            updateOfferLabel("4 PUPPYPADS + 1 FREE GIFT");
          } else if (this.classList.contains("product-3")) {
            selectedQuantity = 6;
            updateGifts(6);
            updateOfferLabel("6 PUPPYPADS + 3 FREE GIFTS");
          }
          updateSessionStorage();
        }

        // Handle size selection
        if (boxClass === "size-box") {
          if (this.classList.contains("small-size")) {
            selectedSize = "small";
            updateSizeLabel("SMALL - 40x60CM");
          } else if (this.classList.contains("medium-size")) {
            selectedSize = "medium";
            updateSizeLabel("MEDIUM - 70x80CM");
          } else if (this.classList.contains("large-size")) {
            selectedSize = "large";
            updateSizeLabel("LARGE - 80x90CM");
          }
          updateSessionStorage();

          const colorAccordionHeader = document.querySelector(".color-accordion-header");
          const colorAccordionContent = document.querySelector(".color-content.accordion-body");
          if (colorAccordionHeader && colorAccordionContent) {
            setActiveAccordion("color");
          }
        }

        // Handle color selection
        if (boxClass === "color-box") {
          if (this.classList.contains("beige-color")) {
            selectedColor = "beige";
            updateColorLabel("BEIGE");
          } else if (this.classList.contains("orange-color")) {
            selectedColor = "orange";
            updateColorLabel("ORANGE");
          } else if (this.classList.contains("white-color")) {
            selectedColor = "white";
            updateColorLabel("WHITE");
          }
          updateSessionStorage();
        }
      });
    });
  }

  // Label update utilities
  function updateOfferLabel(text) {
    const label = document.getElementById("ik31b");
    if (label) label.textContent = text;
  }
  
  function updateSizeLabel(text) {
    const label = document.getElementById("i5ee5");
    if (label) label.textContent = text;
  }
  
  function updateColorLabel(text) {
    const label = document.getElementById("i8hsf");
    if (label) label.textContent = text;
  }
});